import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-social-instagram',
  templateUrl: './social-instagram.component.html'
})
export class SocialInstagramComponent {
  @Input() badgeWrapperSize: string = '50px';
  @Input() badgeIconSize: string = '30px';
  @Input() badgeStyleClass: string;
}
